import { getLoggedRole, isLoggedIn } from 'data-layer-cr/dist/authentication';
import { useMemo } from 'react';
import { Navigate, RouteProps } from 'react-router-dom';

const PrivateRoute = ({ children }: RouteProps): JSX.Element => {
  const role = getLoggedRole();
  const loggedIn = isLoggedIn();
  /** As a fallback, redirect to "null" if no role is found on the  */
  const authType = useMemo(() => role || 'null', [role]);

  return loggedIn ? <>{children}</> : <Navigate to={`/${authType}/login`} />;
};

export default PrivateRoute;
